import StoryModule from '../components/StoryModule';

const PitchArc = () => <StoryModule slug="pitch-arc" />;

export default PitchArc;
